import { SortOrderType } from 'handsontable/plugins/columnSorting';
import { GridSettings } from 'handsontable/settings';
import { compareFunctionFactory as defaultCompareFunctionFactory } from './default';
import { parseNumberStringToNumber } from '../../../../number';
import { FIRST_AFTER_SECOND, FIRST_BEFORE_SECOND } from './constant';
import Handsontable from 'handsontable';

const parseValue = (value: string) => {
  if (Handsontable.helper.isEmpty(value)) {
    return { parsedValue: value, isValid: false };
  }

  const result = parseNumberStringToNumber(`${value}`, true);

  if (isNaN(result)) {
    return { parsedValue: result, isValid: false };
  }

  return { parsedValue: result, isValid: true };
};

export function compareFunctionFactory(
  sortOrder: SortOrderType,
  columnMeta: GridSettings
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (value: any, nextValue: any) => {
    const { parsedValue, isValid: isValueValid } = parseValue(value);
    const { parsedValue: parsedNextValue, isValid: isNextValueValid } =
      parseValue(nextValue);

    if (isValueValid && !isNextValueValid) {
      return FIRST_BEFORE_SECOND;
    } else if (!isValueValid && isNextValueValid) {
      return FIRST_AFTER_SECOND;
    } else {
      return defaultCompareFunctionFactory(sortOrder, columnMeta)(
        parsedValue,
        parsedNextValue
      );
    }
  };
}
